var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSendEmail = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25148",
    "data-name": "Group 25148",
    transform: "translate(-5176 -9190)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70662",
    "data-name": "Path 70662",
    d: "M29,8H27.5V20A1.5,1.5,0,0,1,26,21.5H8V23a3.009,3.009,0,0,0,3,3H26l6,6V11A3.009,3.009,0,0,0,29,8Z",
    transform: "translate(5181 9195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70663",
    "data-name": "Path 70663",
    d: "M29,4H5A3,3,0,0,0,2.015,7L2,25a3.009,3.009,0,0,0,3,3H29a3.009,3.009,0,0,0,3-3V7A3.009,3.009,0,0,0,29,4Zm-.6,6.375L17.8,17.005a1.517,1.517,0,0,1-1.59,0L5.6,10.375a1.274,1.274,0,1,1,1.35-2.16L17,14.5,27.05,8.215a1.274,1.274,0,1,1,1.35,2.16Z",
    transform: "translate(5174 9186)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSendEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send-email.bd3b8093.svg";
export { ForwardRef as ReactComponent };